<template>
  <div class="rebind-phone">
    <NavBar
      class="nav"
      :title="$t('banQuery.封禁查询')"
      :goBack="
        () => {
          this.$router.go(-1);
        }
      "
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.serveInfo.server_name"
        readonly
        clickable
        :name="$t('banQuery.选择区服')"
        :label="$t('banQuery.选择区服')"
        :placeholder="$t('banQuery.点击选择区服')"
        @click="handleServeType"
        :rules="[{ required: true, message: $t('banQuery.请选择区服') }]"
      >
      </van-field>
      <van-field
        v-model="form.role"
        :name="$t('banQuery.角色名称')"
        :label="$t('banQuery.角色名称')"
        :placeholder="$t('banQuery.请输入角色名称')"
        :rules="[{ required: true, message: $t('banQuery.请输入角色名称') }]"
      />
      <div style="margin: 16px;">
        <van-button
          class="login-btn"
          :loading="confirmLoading"
          block
          type="primary"
          size="large"
          native-type="submit"
        >
          {{ $t("banQuery.查询") }}
        </van-button>
      </div>
    </van-form>

    <van-cell-group
      :title="$t('banQuery.角色状态')"
      v-if="roleInfo.status === 1 || roleInfo.status === 2"
    >
      <van-cell :title="roleInfo.info">
        <template #default>
          <van-button type="primary" @click="handleState">
            {{ $t("banQuery.我要申述") }}
          </van-button>
        </template>
      </van-cell>
      <van-cell
        :title="$t('banQuery.解封时间')"
        :value="roleInfo.time"
      ></van-cell>
      <van-cell
        :title="$t('banQuery.封禁原因')"
        :value="roleInfo.reason"
      ></van-cell>
    </van-cell-group>

    <van-field
      v-if="roleInfo.status === 0"
      v-model="roleInfo.info"
      readonly
      :name="$t('banQuery.角色状态')"
      :label="$t('banQuery.角色状态')"
    />

    <van-field
      v-if="banInfo.status === 0 || banInfo.status === 2"
      v-model="banInfo.info"
      readonly
      :name="$t('banQuery.封禁记录')"
      :label="$t('banQuery.封禁记录')"
    />

    <van-cell-group
      :title="$t('banQuery.封禁记录')"
      v-if="banInfo.status === 1"
    >
      <!-- <van-cell :title="roleInfo.info" /> -->
    </van-cell-group>
    <div v-if="banInfo.status === 1">
      <van-row type="flex" class="header">
        <van-col span="8">{{ $t("banQuery.时间") }}</van-col>
        <van-col span="8">{{ $t("banQuery.类型") }}</van-col>
        <van-col span="8">{{ $t("banQuery.原因") }}</van-col>
      </van-row>
      <van-row type="flex" v-for="(item, index) in banInfo.info" :key="index">
        <van-col span="8">
          {{ item.start_time | timeFilter("MM/DD HH:mm") }}
        </van-col>
        <van-col span="8">
          {{ (item.ban_type && banType[item.ban_type]) || "" }}
        </van-col>
        <van-col span="8">
          {{ item.reason || item.keyword }}
        </van-col>
      </van-row>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        @confirm="onConfirm"
        :loading="pickerLoading"
        @cancel="showPicker = false"
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('banQuery.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { getServerList, getServerTypeList, apiGetBanInfo } from "@/api/user";
// import dayjs from 'dayjs';
import { mapState } from "vuex";
import storage from "@/utils/storage";

export default {
  name: "RoleQuery",
  data() {
    return {
      keyword: "",
      pickerLoading: false,
      banType: {
        1: this.$t("banQuery.封号"),
        2: this.$t("banQuery.禁言"),
      },
      form: {
        serveInfo: {},
        role: "",
      },
      columns: [],
      showPicker: false,
      confirmLoading: false,
      serverType: [],
      roleInfo: {
        status: "",
        info: "",
      },
      banInfo: {
        status: "",
        info: "",
      },
    };
  },
  watch: {
    showPicker: {
      handler(val) {
        if (!val) {
          this.keyword = "";
        }
      },
    },
  },
  computed: {
    ...mapState({
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),
    currentColumns() {
      return this.columns.filter((item) => {
        const str = (item.text && item.text.toLowerCase()) || "";
        return str.includes(this.keyword.toLowerCase());
      });
    },
  },
  created() {
    const { game_id } = this.$route.query;
    if (game_id) {
      sessionStorage.setItem("game_id", Number(game_id));
    }
    if (this.defaultRoleInfo.f_id) {
      this.form.role = this.defaultRoleInfo.role_name;
      this.form.serveInfo = {
        server_id: this.defaultRoleInfo.f_id,
        server_name: this.defaultRoleInfo.server_name,
      };
    }
  },
  mounted() {
    this.getServerType();
  },
  methods: {
    // 获取服务器类型
    getServerType() {
      getServerTypeList().then((res) => {
        if (res.code === 0) {
          res.data.forEach((item) => {
            item.text = item.name;
          });
          this.serverType = res.data;
        }
      });
    },
    // 获取区服列表
    getServerList(id) {
      this.pickerLoading = true;
      getServerList({ server_type: id })
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              item.text = item.name;
              item.value = item.id;
            });
            this.columns = res.data;
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },
    // 选择区服
    handleServeType() {
      this.showPicker = true;
      this.columns = this.serverType;
    },
    onConfirm(value) {
      this.keyword = "";
      if (this.columns === this.serverType) {
        this.getServerList(value.id);
      } else {
        this.showPicker = false;
        this.form.serveInfo = {
          server_id: value.id,
          server_name: value.name,
        };
      }
    },
    // 申述
    handleState() {
      this.$router.push({
        name: "Report",
        query: {
          formToken: "f619f7",
          id: 9,
          title: this.$t("banQuery.封禁申述"),
        },
      });
    },
    // 查询
    onSubmit() {
      const params = {
        server_id: this.form.serveInfo.server_id,
        role: this.form.role,
      };
      this.confirmLoading = true;
      apiGetBanInfo(params)
        .then((res) => {
          if (res.code === 0) {
            window.staticFn.customEvent("submit_report", {
              type: "ban_query",
              game_id: storage.getGameId(),
              server_id: this.form.serveInfo.server_id,
              role: this.form.role,
            });
            const { ban_type, bantime, ban_reason } = res.data.data;
            if (ban_type === 0) {
              this.roleInfo.status = 0;
              this.roleInfo.info = this.$t("banQuery.角色状态正常");
            } else if (ban_type === 1) {
              this.roleInfo.status = 1;
              this.roleInfo.info = this.$t("banQuery.封号中");
              this.roleInfo.time = bantime;
              this.roleInfo.reason = ban_reason;
            } else {
              this.roleInfo.status = 2;
              this.roleInfo.info = this.$t("banQuery.禁言中");
              this.roleInfo.time = bantime;
              this.roleInfo.reason = ban_reason;
            }
            if (!res.data.isMy) {
              this.banInfo.status = 0;
              this.banInfo.info = this.$t(
                "banQuery.非绑定角色不能查询封禁记录"
              );
            } else {
              if (res.data.ban_log && res.data.ban_log.length) {
                this.banInfo.status = 1;
                this.banInfo.info = res.data.ban_log;
              } else {
                this.banInfo.status = 2;
                this.banInfo.info = `${this.$t("banQuery.30天内无封禁记录")}`;
              }
            }
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-row {
  color: #646566;
  background-color: #fff;
  &.header {
    color: #000;
    font-size: 14px;
  }
  .van-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 4px;
    border-bottom: 1px solid #ebedf0;
  }
}
/deep/ .van-search {
  padding: 0;
}
</style>
